"use client";

import React, { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useLayout } from "@/lib/context/layout";
import { AppTopbar } from "./AppTopbar";
import { AppSidebar } from "./AppSidebar";
import { AppFooter } from "./AppFooter";
import { ThemeElement } from "./Theme";

export const Shell = ({ children }: { children: React.ReactNode }) => {
    const { setLayoutState } = useLayout();
    const pathname = usePathname();

    useEffect(() => {
        setLayoutState((prev) => ({
            ...prev,
            overlayMenuActive: false,
            staticMenuMobileActive: false,
            menuHoverActive: false,
            profileSidebarVisible: false,
        }));
    }, [pathname]);

    return (
        <>
            <ThemeElement />
            <div className="layout-wrapper min-h-screen">
                <AppTopbar />
                <AppSidebar />
                <div
                    className="layout-main-container flex flex-col min-h-screen justify-between"
                    style={{
                        paddingTop: "var(--topbar-height)",
                        paddingLeft: "var(--sidebar-width-collapsed)",
                        paddingRight: "1.5rem",
                        paddingBottom: "1.5rem",
                    }}
                >
                    <div className="flex-1">{children}</div>
                    <AppFooter />
                </div>
            </div>
        </>
    );
};
